module.exports = __webpack_public_path__ + "img/perica.67f7e33b.png";